import { DiscountType } from 'interfaces/order';
import { GetPriceSummaryDataArgs, PriceSummaryData } from '../types';
import { getCartSubtotal } from './getCartSubtotal';
import { getSavingsItems } from './getSavingsItems';

/**
 * Maps the effective cart into the normalized shape consumed by the price summary UI.
 */
export const getPriceSummaryData = ({
  activePlan,
  effectiveCart,
}: GetPriceSummaryDataArgs): PriceSummaryData => ({
  creditAmount:
    effectiveCart.discount?.type === DiscountType.CREDIT ? effectiveCart.discount.totalDiscount : 0,
  savingsItems: getSavingsItems({ activePlan, effectiveCart }),
  savingsTotal: effectiveCart.itemsTotalReduction,
  shipping: effectiveCart.shipping.price,
  subtotal: getCartSubtotal(effectiveCart),
  subtotalAfterDiscounts: effectiveCart.itemsTotal,
  total: effectiveCart.cartTotal,
});
